import React from "react";
import { Nav } from "../../../../layouts/navbar/nav";
import images from "../../../../constant/images";
import {
  PiFacebookLogoLight,
  PiGoogleLogo,
  PiTwitterLogo,
} from "react-icons/pi";
import Header from "../../../../layouts/header";
import { NavLink } from "react-router-dom";

export const Destination = () => {
  return (
    <>
      <div className="flex flex-col gap-[2rem]  mb-[5rem]">
        {/* <div
          style={{
            backgroundImage: `url(${images.Industry})`,
            height: "60vh",
            backgroundPosition: "40%",
            backgroundRepeat: "no-repeat",
            marginBottom: "0/5rem",
            backgroundSize: "cover",
            position: "relative",
          }}
        >
          <div className="absolute inset-0 bg-black bg-opacity-25"></div>
          <div>
            <Nav />
          </div>
          <div className="h-[50%] flex items-center justify-center">
            <h1 className="text-center relative text-white text-6xl mt-[3.5rem] custom-font">
              Non classé
            </h1>
          </div>
          <svg
            className="absolute bottom-[-9%] left-0 "
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1440 320"
          >
            <path
              class="white"
              fill="#fff"
              fill-opacity="1"
              d="M0,224L60,213.3C120,203,240,181,360,186.7C480,192,600,224,720,245.3C840,267,960,277,1080,250.7C1200,224,1300,170,1380,140L1440,120L1440,320L1380,320C1300,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"
            ></path>
          </svg>
        </div> */}
        <Header image={images.Industry} title={"GTM GOLF BLOG"} />
      </div>

      <div className="px-4 sm:px-8 md:px-12 lg:px-[12rem] mb-8 sm:mb-12 md:mb-16 lg:mb-[8rem]">
        <div className="flex flex-col md:flex-row gap-3">
          {/* Left Column */}
          <div className="flex flex-col gap-2">
            <p className="flex flex-col px-3 py-1 items-center bg-[#45ac4d] text-white font-bold text-lg sm:text-xl">
              28 <span className="text-sm sm:text-base font-medium">Nov</span>
            </p>
            <div className="flex flex-col gap-2">
              <div className="px-3 py-4 text-3xl text-[#4c67a2] border-2">
                <PiFacebookLogoLight />
              </div>
              <div className="px-3 py-4 text-3xl text-[#00acee] border-2">
                <PiTwitterLogo />
              </div>
              <div className="px-3 py-4 text-3xl text-[#d77066] border-2">
                <PiGoogleLogo />
              </div>
            </div>
          </div>

          {/* Right Column */}
          <div className="flex flex-col gap-8">
            <img
              src={images.media1}
              alt=""
              className="w-full max-w-full object-cover"
            />
            <NavLink to="" className="text-3xl sm:text-4xl md:text-5xl custom-font">
              HOW MUCH GROWTH POTENTIAL IS IN MOROCCO AS A GOLF DESTINATION?
            </NavLink>
            <p className="text-[#7c7c7c] text-base sm:text-lg md:text-xl font-medium w-full">
              I’ve attended a few IGTM events and heard much about Morocco as a
              golf destination. It’s piqued my interest! I even had the chance
              to report on Assoufid Golf Club and Atalayoun Golf Resort.
              <br />
              <br />
              Last week, I met with Frank Benzakour and asked him about Morocco
              as a golf destination.
              <br />
              <br />
              How does Morocco position itself as a golf destination?
              <br />
              Morocco has strategically positioned itself as a premier golf
              destination by leveraging several key factors. First of all, it
              boasts a favorable climate with year-round sunshine, making it
              ideal for golfers.
              <br />
              <br />
              Additionally, Morocco offers a diverse range of courses designed
              by renowned architects, set against stunning landscapes that blend
              modernity with the country’s rich cultural heritage.
              <br />
              <br />
              The Moroccan government and the private sector have invested
              substantially in developing world-class golf facilities and
              resorts, attracting international attention.
              <br />
              <br />
              These developments align with Morocco‘s commitment to promoting
              tourism diversification beyond traditional attractions, showcasing
              its golfing infrastructure as a draw for visitors seeking
              luxurious experiences.
              <br />
              <br />
              The state’s support for golf tourism is evident through
              investment, promotion, and infrastructure development, aiming to
              position Morocco as a leading golfing destination in the region.
            </p>

            <img
              src={images.assoufid}
              alt=""
              className="w-full max-w-full object-cover"
            />

            <p className="text-[#7c7c7c] text-base sm:text-lg md:text-xl font-medium w-full">
              Assoufid GC 1st hole Morocco
              <br />
              <br />
              While Spain and Portugal boast established European golf
              destinations, Morocco distinguishes itself by providing an exotic
              experience that seamlessly integrates diverse cultural immersion
              with high-quality courses.
              <br />
              <br />
              In contrast, Turkey focuses on rapid golf infrastructure
              development, emphasizing luxury and large-scale resorts.
              <br />
              <br />
              Morocco’s allure lies in its ability to offer both luxurious golf
              amenities and rich cultural encounters, providing a distinctive
              and appealing choice for golf enthusiasts seeking a blend of
              world-class courses and immersive experiences in an African
              setting.
              <br />
              <br />
              <span className="font-bold text-[#5a5a5a]">
                What makes Moroccan golf courses such a unique experience?
              </span>
              <br />
              Moroccan golf courses and experiences stand out for several
              reasons.
              <br />
              <br />
              <span className="font-bold text-[#5a5a5a]">
                Scenic Diversity:
              </span>{" "}
              The courses blend desert, mountain, and ocean views, creating
              stunning backdrops for golfing. The diverse landscapes provide
              unique challenges and picturesque settings.
              <br />
              <br />
              <span className="font-bold text-[#5a5a5a]">
                Cultural Fusion:
              </span>{" "}
              Many courses integrate Moroccan architecture, design, and
              landscaping, blending modern golf amenities with traditional
              Moroccan elements and adding to the overall ambiance.
            </p>

            <img
              src={images.palm}
              alt=""
              className="w-full max-w-full object-cover"
            />

            <p className="text-[#7c7c7c] text-base sm:text-lg md:text-xl font-medium w-full">
              Palm Golf Ourika Marrakech, Morocco
              <br />
              Climate Advantage: Morocco‘s year-round temperate climate allows
              for golfing in all seasons, attracting golfers seeking consistent
              playing conditions.
              <br />
              <br />
              Luxury and Hospitality: The country boasts luxurious resorts,
              high-end amenities, and excellent hospitality, offering a mix of
              relaxation and top-tier services.
              <br />
              <br />
              Cultural Exploration: Golfing in Morocco often includes cultural
              experiences, from exploring nearby historic sites to indulging in
              local cuisine, providing a well-rounded travel experience beyond
              the game.
              <br />
              <br />
              International Tournaments: Hosting prestigious tournaments and
              events adds to the appeal, showcasing the country’s commitment to
              the sport and attracting global attention to its courses and
              facilities.
              <br />
              <br />
              <span className="font-bold text-[#5a5a5a]">
                How and to what extent does the state support golf tourism?
              </span>
              <br />
              Morocco actively supports golf tourism through various initiatives
              and partnerships:
              <br />
              <br />
              Investments in Infrastructure: The government invests in
              developing world-class golf courses and resorts, often
              collaborating with private investors. These developments aim to
              attract international golfers seeking luxurious experiences.
            </p>

            <img
              src={images.tournament}
              alt=""
              className="w-full max-w-full object-cover"
            />

            <p className="text-[#7c7c7c] text-base sm:text-lg md:text-xl font-medium w-full">
              Tournament in Morocco 064A7985
              <br />
              Hosting Tournaments: Morocco hosts international golf tournaments,
              which not only promote the country as a golfing destination but
              also boost its tourism industry. These events receive government
              support and help showcase Morocco’s golfing infrastructure on a
              global stage.
              <br />
              <br />
              Tourism Promotion: The government collaborates with tourism boards
              and agencies to market Morocco as a golf destination. They
              highlight the country’s diverse courses, favorable climate,
              cultural attractions, and hospitality to attract golfers
              worldwide.
              <br />
              <br />
              Incentives and Partnerships: The state may offer incentives or tax
              breaks to encourage investments in golf-related infrastructure.
              Additionally, partnerships with international golf organizations
              or federations may facilitate the promotion of Moroccan golf
              tourism on a broader scale.
              <br />
              <br />
              Training and Education: The government might invest in training
              programs for local talent in the golf industry, such as caddies,
              instructors, or course maintenance personnel, to enhance the
              overall golfing experience and support employment within the
              sector.
              <br />
              <br />
              Overall, the state’s support for golf tourism is evident through
              investment, promotion, and infrastructure development, aiming to
              position Morocco as a leading golfing destination in the region.
            </p>

            <img
              src={images.anothter}
              alt=""
              className="w-full max-w-full object-cover"
            />

            <p className="text-[#7c7c7c] text-base sm:text-lg md:text-xl font-medium w-full">
              <span className="font-bold text-[#5a5a5a]">
                To what extent and how can Moroccan golf resorts serve the
                highest golfer expectations?
              </span>
              <br />
              Moroccan golf resorts can meet high golfer expectations by
              focusing on several key aspects:
              <br />
              <br />
              Course Quality and Design: Offering impeccably maintained,
              world-class golf courses designed by renowned architects,
              providing a challenging yet enjoyable experience for players of
              all levels.
              <br />
              <br />
              Luxurious Accommodations: Providing upscale accommodations with
              top-notch amenities, spas, and dining options within or near the
              resort to ensure a comfortable and relaxing stay.
              <br />
              <br />
              Exceptional Service: Offering personalized service, attentive
              staff, and excellent hospitality to cater to the specific needs
              and preferences of golfers, ensuring a memorable experience.
              <br />
              <br />
              Diverse Activities: Beyond golf, providing a range of leisure
              activities such as cultural tours, wellness programs, or access to
              nearby attractions to enrich the overall stay.
              <br />
              <br />
              Practice Facilities: High-quality practice areas, driving ranges,
              putting greens, and coaching facilities to allow golfers to
              improve their game.
              <br />
              <br />
              Exclusive Experiences: Golf Trips Morocco-GTM elevates the
              experience for discerning golfers through curated offerings like
              exclusive golf clinics, access to tournaments, and private events,
              infusing a sense of exclusivity into each stay.
              <br />
              <br />
              GTM emphasizes accessibility and convenience by providing easy
              transportation access and streamlined arrangements for tee times
              and related activities.
              <br />
              <br />
              By combining these elements with a commitment to exceptional
              quality, Golf Trips Morocco aims to exceed the expectations of
              golf enthusiasts, creating memorable and satisfying stays for
              those seeking a distinctive blend of luxury and natural beauty.
            </p>
          </div>
        </div>
      </div>

      {/* <div className="flex flex-col ps-[7rem] mb-[8rem]">
        <h1 className="text-2xl  custom-font">Leave A Reply</h1>
        <p className="text-[#7c7c7c] text-[19px] font-[500] ">Vous devez <span className="text-[#45ac4d]">vous connecter</span> pour publier un commentaire.</p>
      </div> */}
    </>
  );
};
